import uiReducer from './uiReducer'
export default uiReducer